// Helper — read the authoritative per-district locality list from
// the same source the homepage map uses (malta_districts_2022.geojson
// → properties.localities, loaded once into MAP_DATA).
//
// Previously several components (TurnoutShareCard, DistrictResultsCard)
// hardcoded their own DISTRICT_LABELS map. Those were wrong — most
// districts had the wrong towns listed because I was filling in from
// memory rather than from the data. Pulling from MAP_DATA fixes that
// and keeps every surface in sync with the map.

import { MAP_DATA } from './buildMapPaths';

/** Raw per-district locality list (ASCII names — matches what the
 *  map renders). Empty array if the district id is unknown. */
export function getDistrictLocalities(districtId: number): readonly string[] {
  const p = MAP_DATA.paths.find((p) => p.id === districtId);
  return p?.properties.localities ?? [];
}

/** Formatted "Locality A · Locality B · Locality C" string for the
 *  district. Pass `maxShown` to truncate long lists with a "+N more"
 *  suffix (Gozo's D13 has 14 localities — too many to display).
 *  Falls back to "District N" if no localities are recorded. */
export function formatDistrictLocalities(
  districtId: number,
  maxShown?: number,
): string {
  const all = getDistrictLocalities(districtId);
  if (all.length === 0) return `District ${districtId}`;
  if (typeof maxShown === 'number' && all.length > maxShown) {
    return `${all.slice(0, maxShown).join(' · ')} · +${all.length - maxShown} more`;
  }
  return all.join(' · ');
}
